export default {
      id: "huge-chevron-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#huge-chevron-right",
      toString: function () {
        return this.url;
      }
    }